type WindowWithDataLayer = Window & { dataLayer?: Array<Record<string, unknown>> }

export const trackSignupCompleted = (method: string) => {
  try {
    const windowWithDataLayer = window as unknown as WindowWithDataLayer
    windowWithDataLayer.dataLayer = windowWithDataLayer.dataLayer || []
    windowWithDataLayer.dataLayer.push({ event: 'signup_completed', method })
  } catch {
    return
  }
}



// WEBPACK FOOTER //
// ./src/libs/track-signup-completed/index.ts